import React from 'react';

import PillarTeaser from './Teaser';

import type { ImmutableTaxonomyPillar } from '../../../types/taxonomy';

export interface PillarProps {
  entity: ImmutableTaxonomyPillar,
  classNames: string,
  link: string,
  viewMode: 'default' | 'full' | 'teaser';
}

const Pillar: React.FC<PillarProps> = (props) => <PillarTeaser {...props} />;

export default Pillar;
